import { render, staticRenderFns } from "./EscolherPermissao.vue?vue&type=template&id=5760ee3c"
var script = {}
import style0 from "./EscolherPermissao.vue?vue&type=style&index=0&id=5760ee3c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports